import { Box } from '@mui/material';
import { FormTitleBox } from '../../../common/components';
import DashboardStatsOverview from './components/DashboardStatsOverview';
import ProjectAnalyticsGrid from './components/ProjectAnalyticsGrid';
import DashboardFilters from './components/DashboardFilters';
import { useDashboard } from './hooks/useDashboard';

/**
 * Dashboard de análisis y seguimiento de proyectos
 * Panel de control analítico para supervisión de progreso y calidad por proyecto
 */
const DashboardManagement = () => {
  const {
    // Data principal
    projectsWithAnalytics,
    isLoading,
    
    // Estadísticas agregadas
    dashboardStats,
    
    // Filtros
    filter,
    handleFilter,
  } = useDashboard();

  return (
    <Box>
      <FormTitleBox
        title="Dashboard de Análisis | Seguimiento de Proyectos"
        showButton={false}
        showSearch={true}
        searchLabel="Buscar proyecto por nombre o número"
        searchValue={filter.search || ''}
        onSearchChange={(value) => handleFilter('search', value)}
        searchSize="medium"
      />

      <DashboardStatsOverview
        stats={dashboardStats}
        isLoading={isLoading}
      />

      <DashboardFilters
        statusFilter={filter.status || 'all'}
        sortBy={filter.sortBy || 'name'}
        viewMode={filter.viewMode || 'cards'}
        onStatusFilterChange={(value) => handleFilter('status', value)}
        onSortChange={(value) => handleFilter('sortBy', value)}
        onViewModeChange={(value) => handleFilter('viewMode', value)}
      />

      <ProjectAnalyticsGrid
        projects={projectsWithAnalytics || []}
        isLoading={isLoading}
        viewMode={filter.viewMode || 'cards'}
      />
    </Box>
  );
};

export default DashboardManagement;